import React from 'react'
import { Icon } from './Plus.elements'

type Props = {
  className?: string
}

export const PlusIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 24 24"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path stroke="currentColor" strokeWidth="2" d="M12 4v16M4 12h16" />
  </Icon>
)
